import React, { useState, memo, useEffect } from 'react'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { money } from '@/Helper'
import DetailRowChild from './DetailRowChild';


const GeneralRowParent = ({ data, showDetail: defaultShowDetail, no, variants }) => {

    const [d, setD] = useState(data)
    const [showDetail, setShowDetail] = useState(false)
    const handleShowDetail = () => {
        setShowDetail(!showDetail)
    }

    useEffect(() => {
        setShowDetail(!showDetail)
    }, [defaultShowDetail])

    useEffect(() => {
        setD(data)
        setShowDetail(false)
    }, [data, variants])

    return (
        <>
            <tr>
                <td>{no}</td>
                <td className="cell-width-as-content cell-highlight">
                    <span className="trigger-show-detail" onClick={handleShowDetail}>
                        {d.code} {d.products.length && <KeyboardArrowDownIcon className="info-icon" />}
                    </span>
                </td>
                <td>{d?.type ?? 'N/a'}</td>
                <td>{d?.name ?? 'N/a'}</td>
                <td>{d.total_category || 0}</td>
                <td>{d.total_product || 0}</td>
                {
                    variants.map((lv, lvIdx) => {
                        let qty = 0;
                        d.variants.forEach(variant => {
                            qty += variant?.types?.[lvIdx]?.stock ?? 0
                        })
                        return <td key={`parentvariant${lvIdx}`}>{qty}</td>
                    })
                }
                <td>{d.total_stock}</td>
                <td>{d.total_reject}</td>
                <td>Pcs</td>
                <td className="cell-currency cell-tr">{money(d.total_value)}</td>
            </tr>

            {showDetail && <DetailRowChild
                indexParent={no}
                show={showDetail}
                variants={variants}
                products={d.products}
            />}

        </>
    )
}



export default memo(GeneralRowParent)